// UK Postcode validation regex
const POSTCODE_REGEX = /^[A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2}$/i;

/**
 * Validates a UK postcode format
 * @param {string} postcode - The postcode to validate
 * @returns {boolean} - True if valid format
 */
export function validatePostcode(postcode) {
  if (!postcode || typeof postcode !== 'string') return false;
  return POSTCODE_REGEX.test(postcode.trim());
}

/**
 * Formats a postcode to standard format (e.g., "SW1A 1AA")
 * @param {string} postcode - The postcode to format
 * @returns {string} - Formatted postcode
 */
export function formatPostcode(postcode) {
  if (!postcode) return '';

  const cleaned = postcode.replace(/\s/g, '').toUpperCase();

  // Insert space before last 3 characters
  if (cleaned.length >= 5) {
    return cleaned.slice(0, -3) + ' ' + cleaned.slice(-3);
  }

  return cleaned;
}

/**
 * Validates and formats a postcode
 * @param {string} postcode - The postcode to validate and format
 * @returns {{valid: boolean, formatted: string, error: string|null}}
 */
export function processPostcode(postcode) {
  const trimmed = postcode.trim();

  if (!trimmed) {
    return { valid: false, formatted: '', error: 'Postcode cannot be empty' };
  }

  const formatted = formatPostcode(trimmed);
  const valid = validatePostcode(formatted);

  return {
    valid,
    formatted,
    error: valid ? null : 'Invalid UK postcode format'
  };
}
